























import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';
import { Machine } from '../models/machine';

// Service
import { Datasource } from '../services/datasource'
import { Report } from '../models/report';

@Component({
  components: { },
})
export default class TypeaheadSearch extends Vue {

    @Prop() value!:string

    source:Datasource

    items : Machine[] = []
    current:number = -1
    show = false
    loading = false

    constructor() {
        super()
        this.source = Datasource.shared
    }

    isActive(index:number) {
      return this.current == index;
    }

    hit(e:Event) {
        this.value = this.items[this.current].serial_number
        this.selected(this.items[this.current]);

        if (this.hasItems && this.current >= 0)
        e.preventDefault();

        this.onReset();

    }

    @Emit()
    selected(machine:Machine) { }

    up(e:Event) {
      if (this.show)
        e.preventDefault();
      if (this.current > 0) this.current--;
    }

    down(e:Event) {
      if (this.show)
        e.preventDefault();
      if (this.current < this.items.length-1) this.current++;
    }

    setActive(index:number) {
      this.current = index
    }

    outSideClickEvent(event:Event) {
      this.show = false
    }
    
    onReset() {
      this.reset();
    }

    reset() {
      this.loading = false
      this.show = false
      this.current = -1
    }

    toggleShow() {
      this.show = !this.show;
    }

    update() {
      if (!this.value) {
        this.onReset();
        return;
      }

      this.source.searchMachines(this.value)
        .then(([machines, total]) => {
        //console.log(machines)
            this.items = machines
        })
        .catch(console.error)

      this.loading = true;
      if(this.items.length > 0){
          this.show = true
      }
      
    }

    // computed

    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0
    }

    isEmpty() {
      return !this.value && !this.loading;
    }

    isDirty() {
      return !!this.value && !this.loading;
    }

    mounted() {
        //console.log(this.value);
        //this.id = Math.random().toString(36).substr(2, 16)
    }

}

